export default {
  data() {
    return {
      znsy: [
        { name: '产品痛点', children: [
          { label: '01', desc: '收运计划按照人工经验排版，车辆资源浪费' },
          { label: '02', desc: '收运垃圾质量差，无管控措施' },
          { label: '03', desc: '车辆无实时调度，车辆调度解决不及时' },
          { label: '04', desc: '签约耗费大量人力物力' },
          { label: '05', desc: '生产报表由人员专门统计，效率低' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '生产单位端',
              subtitle: '入驻签约 | 收运提报 | 收运通知',
              desc: '一键申请收运</br>可预约时间，会根据预约时间安排人员上门</br>实时查看车辆、人员等收运信息，随时联系沟通</br>线上、线下两种支付方式，方便快捷</br>评价反馈，及时反馈意见，得到更好的服务',
              url: require('@/assets/images/solution/znsy_p1.png'),
            },
            { title: '司机作业端',
              subtitle: '接收任务 | 导航收运避免漏收',
              desc: '接收收运计划,作业人员登陆系统,待办任务、任务详情一目了然</br>系统根据时间、计划、定位自动规划收运路线</br>对作业人员危险行为进行视频分析,及时提醒报警</br>车辆、设备出现故障,及时报修,任务过程中及时调度车辆设备支援',
              url: require('@/assets/images/solution/znsy_p2.png'),
            },
            { title: '运行管理端',
              subtitle: '车辆维护 | 视频轨迹回放',
              desc: '提供设备故障维修管理,故障申报,备品备件,审核管理等</br>车辆仓标签可以按功能快捷跳转,也能和车辆列表互动</br>除实时路径外,提供轨迹回放功能,便于事后核实检查</br>记录车辆视频监控数据,可根据时间段进行回放查看',
              url: require('@/assets/images/solution/znsy_p3.png'),
            }
          ],
          children: [
            { label : '产生单位路径获取',
              desc: '依据各餐馆的垃圾收运的位置，利用高德地图导航功能，获取产生单位的点位、距离',
              url: require('@/assets/images/solution/znsy_01.png'),
            },
            { label: '产生量预估',
              desc: '依据各餐馆的垃圾收运的历史产生量信息，采用预测模型，对每家餐馆的垃圾产生量进行预测' ,
              url: require('@/assets/images/solution/znsy_02.png'), 
            },
            { label: '收运车辆确定',
              desc: '依据预估的产生单位产生量数据及收运公司所有车辆的收运能力，确定采用多少辆车，何种规格的车进行收运工作' ,
              url: require('@/assets/images/solution/znsy_03.png'),
            },
            { label: '路径优化',
              desc: '根据划分好的车辆和相关的产生单位，使用遗传算法，进行收运路线的优化',
              url: require('@/assets/images/solution/znsy_04.png'),
            }] 
        },
        { name: '应用场景', desc: '' , url: [require('@/assets/images/product/img_wei_002.png'),] },
        {},
        { name: '成功案例', children: [{ label: '赤峰智能收运系统', desc: '提供车辆定位导航，利用大数据模型算法技术实现路径优化、智能调度，从而大大提升了收运效率...', path: '/solition_lower/CaseCfznsyDetail' }] },
      ],
      zngk: [
        { name: '产品痛点', children: [
          { label: '01', desc: '补贴机制，布局分散，监管较难' },
          { label: '02', desc: '组分不同，工艺参数变化效率低下，运行成本高' },
          { label: '03', desc: '无人值守、安全状态和环境影响无监测' },
          { label: '04', desc: '功能单一，信息化管理不完善' },
          { label: '05', desc: '结构集成，操作繁琐' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '设备管理问题解决方案',
              subtitle: '',
              desc: '通过设备运维管理系统（分管理端、移动端）实现运维提示、备品备件信息、维护保养指导、寿命预测等',
              url: require('@/assets/images/solution/zngk_p1.png'),
            },
            { title: '安全管理问题解决方案',
              subtitle: '',
              desc: '可通过人员定位系统实现（越界报警、静止报警、滞留报警、超/缺员报警、一键呼救等），结合设备运行状态判断工作人员状态',
              url: require('@/assets/images/solution/zngk_p2.png'),
            },
            { title: '降本增效问题解决方案',
              subtitle: '',
              desc: '通过数据采集、清洗、分析、建模、优化等一系列方法，完成对生产工艺的参数优化，可达到提高生产效率、降低运营成本',
              url: require('@/assets/images/solution/zngk_p3.png'),
            },
            { title: '软件融合问题解决方案',
              subtitle: '',
              desc: '环境产业平台按照工业互联网平台进行搭建，预留第三方软件接口，包括ERP、OKR、PLM等',
              url: require('@/assets/images/solution/zngk_p4.png'),
            },
            { title: '形象提升问题解决方案',
              subtitle: '',
              desc: '通过3D建模、Unity动画设计，动态展示厂区、设备实时状态，提高形象展示',
              url: require('@/assets/images/solution/zngk_p5.png'),
            }
          ],
          children: [
            { label : '设备自动化',
              desc: '建设覆盖厂区所有生产厂区的控制系统（PLC、DCS），实现对所有生产链的监测与控制',
              url: require('@/assets/images/solution/zngk_01.png'),
            },
            { label: '过程数字化',
              desc: '借助覆盖全厂区的网路平台实现生产过程数据的实时采集，快速掌握生产运行情况' ,
              url: require('@/assets/images/solution/zngk_02.png'), 
            },
            { label: '工艺模型化',
              desc: '基于数据采集、分析、验证，制作最优生产工艺模型，实现降本增效' ,
              url: require('@/assets/images/solution/zngk_03.png'),
            },
            { label: '厂区可视化',
              desc: '根据设计图纸搭建三维可视化工厂，与生产工艺、设备状态、点检巡检功能进行集成，提高生产管理效率' ,
              url: require('@/assets/images/solution/zngk_04.png'), 
            },
            { label: '决策科学化',
              desc: '利用大数据技术，对各项数据进行集中存储和分析，协助领导层及时发现问题、分析问题、解决问题' ,
              url: require('@/assets/images/solution/zngk_05.png'),
            },
            { label: '平台集成化',
              desc: '建立信息集成平台，以智能生产为核心，关联收运系统、安防系统，形成一个完整可靠、有效的整体',
              url: require('@/assets/images/solution/zngk_06.png'),
            }] 
        },
        {},
        {},
        { name: '成功案例', children: [
          { label: '旺能智能管控系统', desc: '利用物联网关将PLC等控制系统数据统一采集，通过4G网络上传至云端服务器，实现设备远程监控...', path: '/solition_lower/CaseDetail' },
          { label: '富阳餐厨垃圾处置智能工厂', desc: '通过传感器采集数据，系统进行数据分析，及时提供预警消息，确保环境安全...', path: '/solition_lower/CaseZjnxhjjDetail' },
          { label: '茅台酒糟智能管控系统', desc: '通过分布式智慧控制系统的构建，依托整体平台的定位，将数据直观、动态、智慧、交互的展示和运行...', path: '/solition_lower/CaseZjnznhDetail' }] 
        },
      ],
      shdl: [
        { name: '产品痛点', children: [
          { label: '01', desc: '尽量减少人工调度' },
          { label: '02', desc: '尽量保证作业轨迹准确率' },
          { label: '03', desc: '应急调度保证快速进行' },
          { label: '04', desc: '尽可能提高收运清扫效率，合理规划作业最优路径' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '作业车辆管理',
              subtitle: '',
              desc: '主要针对洗扫、洒水、清洗等环卫车辆作业模式进行规范化、精细化、智能化管理，管理内容包括为每辆作业车的作业状态实时监控、行驶线路规划和考评、作业区域管理、自动形成针对作业车辆的考核评价报表。',
              url: require('@/assets/shenghe/case1.png'),
            },
            { title: '作业人员管理',
              subtitle: '',
              desc: '系统可实现对保洁员到岗时间及时收集、随时抽查保洁员当前是否在岗等功能，针对环卫业务，系统平台可制定作业规划,按作业规划对作业事件处置等方面的统计分析过程实时监控，最后实现作业工作量、作业规范化程度',
              url: require('@/assets/shenghe/case2.png'),
            },
            { title: '垃圾清运',
              subtitle: '',
              desc: '系统接收垃圾收集点设备状态，根据垃圾设备空满情况、车辆数车辆载重、垃圾转运站位置等因素规划收运计划，并下发至司机作业端司机按照导航进行收运。节省收运作业时间',
              url: require('@/assets/shenghe/case3.png'),
            }
          ],
          children: [
            { label: '清扫保洁智能化管理',
              desc: '',
              url: require('@/assets/shenghe/1.png'),
            },
            { label: '垃圾清运智能化管理',
              desc: '',
              url: require('@/assets/shenghe/2.png'),
            },
            { label: '护栏清洗智能化管理',
              desc: '',
              url: require('@/assets/shenghe/3.png'),
            },
            { label: '隧道桥梁智能化管理',
              desc: '',
              url: require('@/assets/shenghe/4.png'),
            },
            { label: '小广告清除智能化管理',
              desc: '',
              url: require('@/assets/shenghe/5.png'),
            },
            { label: '垃圾中转站智能化管理',
              desc: '',
              url: require('@/assets/shenghe/6.png'),
            }
          ] 
        },
        {},
        {},
        { name: '成功案例', children: [
          { label: '升禾智慧环卫系统', desc: '升禾环保以专业技术为城市环卫事业（城市基础项目）提供一站式解决方案...', path: '/detail_page/CaseShengHeDetail' }] 
        },
      ],
      tjcy: [
        { name: '产品痛点', children: [
          { label: '01', desc: '补贴机制，布局分散，监管较难' },
          { label: '02', desc: '组分不同，工艺参数变化效率低下，运行成本高' },
          { label: '03', desc: '无人值守、安全状态和环境影响无监测' },
          { label: '04', desc: '应急调度保证功能单一，信息化管理不完善快速进行' },
          { label: '05', desc: '结构集成，操作繁琐' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '清扫保洁智能化管理',
              subtitle: '',
              desc: 'DTU协议与设备本地通信互通，具备实时数据传输、分析功能</br>对垃圾处理量、废油量、有机基肥量、温度、状态实时监控和GPS定位跟踪，实时生成各个环节的数据报表',
              url: '',
            },
            { title: '降本增效有效措施',
              subtitle: '',
              desc: '人工成本有效降低，节能保障措施，环境效益、经济效益、资源效益曲线趋势大数据分析增效明显</br>能耗降低2/3；专用活性微生物菌剂充分增效实现厨余垃圾的减量化、无害化、资源化',
              url: '',
            },
            { title: '系统安全保障体系',
              subtitle: '',
              desc: '平台对厨余垃圾分散处理站点的环境影响也进行了限值规定，如废水、废气、噪音等</br>同时对电气、安全方面进行规定',
              url: '',
            },
            { title: '高度融合ERP、PLM信息化管理',
              subtitle: '',
              desc: '预留软件接口，可实现巡检、维保、检修工作的规范化和量化管理',
              url: '',
            },
            { title: '开发APP和小程序应用端, 建立便捷化的售后运维体系',
              subtitle: '',
              desc: '系统具有智能物联控制传输功能</br>实时查看信息，故障预报警，一键报修，日报精准推送等',
              url: '',
            }
          ],
          children: [] 
        },
        {},
        {},
        { name: '成功案例', children: [
          { label: '鼓楼医院餐厨垃圾智慧处理系统', desc: '利用物联网关将PLC等控制系统数据统一采集，通过4G网络上传至云端服务器，实现设备远程监控...', path: '/detail_page/CaseTianjianDetail' },
          { label: '深圳罗湖区翠竹街道厨余垃圾处理智能管控系统', desc: '项目采用智慧厨余设备，就近就地处理厨余垃圾...', path: '/detail_page/CaseTianjianDetail1' }] 
        },
      ],
      taidi: [
        { name: '产品痛点', children: [
          { label: '01', desc: '作业路径规划缺乏科学性，仅凭经验作为依据，公司经营成本无法合理控制' },
          { label: '02', desc: '不能实时了解作业人员及车辆的位置情况、面对突发事件很难安排有效的统筹调度' },
          { label: '03', desc: '环卫作业成效缺乏有效监督体系，工作质量难以保证' },
          { label: '04', desc: '缺乏上下级部门数据联动，运营效率不高，作业管理更多依赖于人力，管理与经营成本高昂' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '实时定位/历史轨迹查询',
              subtitle: '',
              desc: '实时查看车辆及工人的位置分布情况，对其出勤、到岗情况一目了然。 实时记录车辆及工人的作业轨迹，清楚掌握行进路线并可进行快速回放',
              url: require('@/assets/taidi/dingwei.png'),
            },
            { title: '车辆油耗/油量管理',
              subtitle: '',
              desc: '实时记录车辆、车队油量消耗情况，对异常情况进行提示和标记，方便追溯问题，统计分析</br>能耗降低2/3；专用活性微生物菌剂充分增效实现厨余垃圾的减量化、无害化、资源化',
              url: require('@/assets/taidi/oil.png'),
            },
            { title: '地理围栏',
              subtitle: '',
              desc: '设置地理围栏范围，车辆及工人如果超过范围将实时记录并通知管理者',
              url: require('@/assets/taidi/weilan.png'),
            },
            { title: '监控警报',
              subtitle: '',
              desc: '实时获知车辆及工人违规行为，及时发现问题，解决问题。奖惩考核，有据可查',
              url: require('@/assets/taidi/jiankong.png'),
            },
            { title: '绩效指数',
              subtitle: '',
              desc: '基于车辆运行的指标数据，进行大数据统计和分析，产出指导意义的绩效指数',
              url: require('@/assets/taidi/jixiao.png'),
            },
            { title: '作业质量',
              subtitle: '',
              desc: '按不同车辆、车队汇总作业质量、作业回放等数据，及时的为管理者提供准确、科学的数据报表，帮助管理者改进管理提升效率',
              url: require('@/assets/taidi/zuoye.png'),
            }
          ],
          children: [] 
        },
        {},
        {},
        { name: '成功案例', children: [{ label: '烟台福山环卫大脑智能平台', desc: '通过“环卫大脑”实现机械保洁，餐厨收运，垃圾收运线路自动规划...', path: '/detail_page/CaseTaidiDetail' }] 
        },
      ],
      mycclj: [
        { name: '产品痛点', children: [
          { label: '01', desc: '对餐厨垃圾产生源头缺乏有效管理' },
          { label: '02', desc: '收运作业规划不科学，效率低作业质量无从监管' },
          { label: '03', desc: '处置环节缺少与收运环节的数据对接无法形成业务闭环' },
          { label: '04', desc: '处置厂设备及能耗物耗管理粗放,运营成本高' },
          { label: '05', desc: '无有效的排放监管体系,容易造成二次污染' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '餐厨垃圾产生源头的数字化管理',
              subtitle: '',
              desc: '通过商家线上互动平台，为商家提供快速签约、产量申报、线上互动与评价反馈等功能，建立商家数字化档案，脱离纸质办公；同时通过RFID为每个餐桶设立电子标签，实时掌握商家垃圾产生量、变化趋势，以及为企业和政府主管单位提供直观的城市餐厨垃圾产生趋势与分布情况，反哺企业资源调配与政府主管单位的政策制定',
              url: '',
            },
            { title: '科学手段提升收运效率与质量',
              subtitle: '',
              desc: '在收运环节充分利用物联网与人工智能等技术，将人工智能下沉至人员排班、路线智能规划、智能调度、垃圾桶自动识别、垃圾质量智能分析、抛洒滴漏预警等多个实际业务作场景，有效提升收运效率与收运质量，并通过科学手段研判违规行为从而规范收运作业标准',
              url: '',
            },
            { title: '消除收运与处置的信息孤岛现象',
              subtitle: '',
              desc: '通过与餐厨处置终端的地磅称重系统对接，获取车辆过磅数据，并与车载称重系统数据进行对比分析，并提供多维度的收运报表统计，方便管理人员对企业收运趋势有更观的了解，通过打通收运与处置环节的数据屏障，也可以有效的监督收运质量，防止出现偷、售油脂的情况',
              url: '',
            },
            { title: '人工智能与大数据的应用，降本增效',
              subtitle: '',
              desc: '系统不仅提供精细化的设备全生命周期管理，从设计、采购、运行、保养维护到报废更新整个生命周期的信息收集、整理、分析，实时监控设备运行状态，利用大数据技术进行设备效能分析，同时在处置环节，采用人工智能与大数据技术，为处置终端提供精准加药与精准曝气等功能，优化企业的能耗物耗，降低70%以上的无效能耗、物耗成本',
              url: '',
            },
            { title: '从万物互联到智慧感知',
              subtitle: '',
              desc: '系统通过采集各类传感器与化验设备的数据，也可结合处置终端的人工化验记录进行统计分析，对各类关键排放指标进行实时跟踪，有效掌握处置终端各类排放指标的变化趋势，系统可提前维护预警阈值，当排放指标超过阈值时，进行实时预警，保障安全排放',
              url: '',
            },
          ],
          children: [] 
        },
        {},
        {},
        { name: '成功案例', children: [{ label: '西安维尔利环保科技有限公司环卫信息管理系统', desc: '通过对前端收运流程的优化，餐厨垃圾收运效率提升至少30%...', path: '/detail_page/CaseWeierliDetail1' }] 
        },
      ],
      xinye: [
        { name: '产品痛点', children: [
          { label: '01', desc: '管理方式原始，办公效率低' },
          { label: '02', desc: '数据未得到挖掘和应用，增加维修成本' },
          { label: '03', desc: '缺乏有效管理手段，增加管理成本' },
          { label: '04', desc: '信息缺乏共享，不利于协作办公' }] 
        },
        { 
          name: '主要功能', 
          card: [],
          children: [
            { label: '设备动态台账管理',
              desc: '设备KKS编码为核心，关联缺陷管理、预防性维护、设备状态等业务，建立企业设备管理数据中心，实现设备全生命周期动态台账的管理',
              url: require('@/assets/images/solution/cwgl_01.png'),
            },
            { label: '缺陷消缺管理',
              desc: '实现缺陷从登记-处理-验收全流程的闭环管理，支持移动APP的便捷处理，满足缺陷故障分析、分类统计、消缺率统计等管理',
              url: require('@/assets/images/solution/cwgl_02.png'),
            },
            { label: '设备预防性维护管理',
              desc: '实现设备周期性工作设置-自动派发-任务闭环的管理，规避设备运行故障',
              url: require('@/assets/images/solution/cwgl_03.png'),
            },
            { label: '设备状态管理',
              desc: '实现设备全生命运行时长的管理，对设备运行周期、时长、原因进行统计与分析',
              url: require('@/assets/images/solution/cwgl_04.png'),
            }
          ] 
        },
        {},
        {},
        { name: '成功案例', children: [{ label: '光大环保能源（南京）垃圾发电项目', desc: '项目基于SAAS架构开发出具有自主知识产权的升禾环境云平台...', path: '/detail_page/CaseNanjingDetail' }] 
        },
      ],
      mysly: [
        { name: '产品痛点', children: [
          { label: '01', desc: '线下纸质管理，信息滞后，管理层与执行层容易出现信息偏差' },
          { label: '02', desc: '生产过程人工监控，可靠性不足，问题发现滞后，影响出水水质' },
          { label: '03', desc: '缺乏对设备的科学管养维护体系，容易造成重资产的损耗' },
          { label: '04', desc: '电能耗与药剂等物耗管理粗放，运营成本高' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '建立数字化、集约化的管理模式',
              subtitle: '',
              desc: '建立污水处理厂的所有生产管理环节线上化、数字化与集约化的管理模式，将数据报表、数据分析、能耗物耗管理、设备管理、人员管理与巡检管理都通过一个平台完成全方位的线上闭环管理，完成数字化与智慧化的运营管理升级',
              url: '',
            },
            { title: '通过万物互联实现透彻感知',
              subtitle: '',
              desc: '平台通过对设备PLC以及各类智能设备的解析，采集实时生产数据，再经由牧云智能网关进行数据的存储、清洗并上传至云端，通过平台的大数据处理技术，呈现可视化的管理界面。平台物联网强连接工厂的智能终端设备，实现对设备的远程控制，提高工厂生产自动化的程度。同时，对工厂的重要设备进行远程监控，结合工艺仿真动态流程图，全方位无死角地监控工厂的生产运行状态，达到安全生产、降本增效、达标排放的最终目的',
              url: '',
            },
            { title: '重资产的全生命周期管理',
              subtitle: '',
              desc: '系统不仅提供精细化的设备全生命周期管理，从设计、采购、运行、保养维护到报废更新整个生命周期的信息收集、整理、分析，实时监控设备运行状态，利用大数据技术进行设备效能分析，使设备的动、静态信息能集中到系统平台进行管理，保障安全生产的同时，维护好工厂的设备资产',
              url: '',
            },
            { title: '人工智能与大数据的应用，降本增效',
              subtitle: '',
              desc: '系统不仅提供精细化的设备全生命周期管理，从设计、采购、运行、保养维护到报废更新整个生命周期的信息收集、整理、分析，实时监控设备运行状态，利用大数据技术进行设备效能分析，同时在处置环节，采用人工智能与大数据技术，为处置终端提供精准加药与精准曝气等功能，优化企业的能耗物耗，降低70%以上的无效能耗、物耗成本',
              url: '',
            },
            { title: '精细化的能耗物耗管理',
              subtitle: '',
              desc: '平台通过对生产耗电量、物料进货、消耗及库存进行一体化管理，对入库物料的采购时间、供应商及价格进行控制。可实现库存物品进行查询和汇总，让管理人员时刻对物料库存情况做到心里有数，清晰了解产出效率，有效减少70%以上生产中存在的无效能耗、物耗成本',
              url: '',
            },
          ],
          children: [] 
        },
        {},
        {},
        { name: '成功案例', children: [{ label: '大辛渗滤液运营管理系统', desc: '通过建设“少人/无人”化的智慧型工厂，实现95%以上业务线上化处理...', path: '/detail_page/CaseWeierliDetail2' }] 
        },
      ],
      zzytzhhw: [
        { name: '产品痛点', children: [
          { label: '01', desc: '缺乏经验、作业制定不合理、验收标准高、难以避免的罚款' },
          { label: '02', desc: '管理过程混乱不堪，严重的还可能会遭到市民的投诉' },
          { label: '03', desc: '常规化考核没有办法进行量化统计,员工的积极性和质量较差' },
          { label: '04', desc: '对于环卫司机、环卫工人来说高强度、内容单一的环卫作业' },
          { label: '05', desc: '环卫行业转型初期，有经验的项目人员不好找，企业的试错成本较高' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '系统管理',
              subtitle: '',
              desc: '主要用于显示和管理本月成本信息、通知公告信息、人员信息、车辆信息、业绩排名信息和当日天气信息',
              url: '',
            },
            { title: '车辆管理',
              subtitle: '',
              desc: '主要用于管理作业车辆的基本信息、维护车辆基本状况以及对作业车辆进行调度',
              url: '',
            },
            { title: '设施管理',
              subtitle: '',
              desc: '主要用于办公室工作人员采购环卫设备，还有对设备的入库、出库管理',
              url: '',
            },
            { title: '数据挖掘分析',
              subtitle: '',
              desc: '用于出勤统计、用水量统计、人员加班情况统计、设施成本费用统计、巡检统计和报警统计',
              url: '',
            },
            { title: '车辆监控',
              subtitle: '',
              desc: '通过在车辆上安装车载GPS，实时查看车辆的位置信息，掌握车辆的历史行动轨迹，从而实现实时监管车辆的作业过程',
              url: '',
            },
            { title: '业绩考核',
              subtitle: '',
              desc: '工作人员可以通过该功能查看环卫工人的出勤、到岗以及工作完成度等情况，为该工人的业绩考核提供数据依据',
              url: '',
            },
            { title: '环卫一张图',
              subtitle: '',
              desc: '通过显示在线人数，在线车辆，并可随时查看自己安装的街道摄像头，实现实时监控管理区域内的人员车辆情况',
              url: '',
            },
            { title: '网格化管理',
              subtitle: '',
              desc: '可以直观查看作业区域划分情况，以及每个区域人员的分布情况。列表展示内容包括网格编号、网格区域名称、作业人员数量、作业人员姓名、作业时间要求等',
              url: '',
            },
            { title: '轨迹回放',
              subtitle: '',
              desc: '系统通过图形化方式在地图上回放车辆作业全过程，实现对环卫车辆历史作业轨迹的查询和回放',
              url: '',
            },
            { title: '视频监控',
              subtitle: '',
              desc: '显示在线以及未在线的视频监控设备，实时掌握道路上的车辆情况和清洁情况',
              url: '',
            },
          ],
          children: [] 
        },
        {},
        {},
        { name: '成功案例', children: [{ label: '中再生双江智慧环卫系统', desc: '建立一套环卫工作全范围管控体系，通过GPS定位技术、地理信息技术GIS...', path: '/detail_page/CaseZhongZaiShengDetail1' }] 
        },
      ],
      zzytgtfw: [
        { name: '产品痛点', children: [
          { label: '01', desc: '医疗废物对生态环境和人体健康危害较大' },
          { label: '02', desc: '医疗废物回收机制不健全，没有完整的追溯反馈' },
          { label: '03', desc: '功能单一,信息化管理不完善，医疗废物转移过程未得到监管' },
          { label: '04', desc: '监管人员不足、专业水平不足、监管不到位的问题' },
          { label: '05', desc: '结构集成，操作繁琐' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '管理员大屏展示',
              subtitle: '',
              desc: '平台门户为废物收集点单位（包含医疗机构、回收站）、废物中转单位、运输单位以及废物处置单位开放了不同的服务以填报相关数据',
              url: '',
            },
            { title: '收集点单位监管',
              subtitle: '',
              desc: '收集点单位监管用于对医疗废物回收企业的危废收集、运输下单及其他环保相关信息进行管理，可以选择由中转站派车运输或者自行派车进行运输',
              url: '',
            },
            { title: '派车任务监管',
              subtitle: '',
              desc: '自行运输或者由上级机构进行派车，对运输车辆以及驾驶员进行指派',
              url: '',
            },
            { title: '中转站单位可回收物收运',
              subtitle: '',
              desc: '司机到达收集点等收运地点后，对可回收物进行收运，生成收运条形码',
              url: '',
            },
            { title: '收运确认',
              subtitle: '',
              desc: '下单机构对收运进行确认，以便收运司机进行运输',
              url: '',
            },
            { title: '运输任务',
              subtitle: '',
              desc: '收运司机对派车任务进行运输，向平台发送运输路线以及运输的可回收物类型',
              url: '',
            },
            { title: '入库确认',
              subtitle: '',
              desc: '司机到达上级机构，上级机构对收运物品进行入库确认操作',
              url: '',
            },
            { title: '出库管理',
              subtitle: '',
              desc: '对已入库的可回收物按条形码批次进行出库，并进行派车管理',
              url: '',
            },
            { title: '收集点数据统计',
              subtitle: '',
              desc: '对收集点企业回收数据进行统计',
              url: '',
            },
            { title: '中转站数据统计',
              subtitle: '',
              desc: '对中转站收运、出库数据进行统计分析',
              url: '',
            },
            { title: '生产基地数据统计',
              subtitle: '',
              desc: '对生产基地入库、加工、出库数据进行统计分析',
              url: '',
            },
            { title: '溯源一张图',
              subtitle: '',
              desc: '根据产品收运时产生的条形码，对整个可回收物进行全过程监管溯源',
              url: '',
            },
          ],
          children: [] 
        },
        {},
        {},
        { name: '成功案例', children: [{ label: '中山市固体废物在线监控管理平台', desc: '利用物联网技术，对企业信息进行管理，规范其基础信息，收集企业工况信息...', path: '/detail_page/CaseZhongZaiShengDetail4' }] 
        },
      ],
      zzytljfl: [
        { name: '产品痛点', children: [
          { label: '01', desc: '分类名称没有做到见名知意，很难分清垃圾的属性' },
          { label: '02', desc: '民众垃圾分类积极性不高' },
          { label: '03', desc: '垃圾分类宣传困难,民众垃圾分类意识差' },
          { label: '04', desc: '功能单一，信息化管理不完善' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '垃圾投放信息化',
              subtitle: '',
              desc: '利用物联网将智能垃圾箱数据进行传递,具备实时数据传输,分析功能,对垃圾箱存量,类型,投放记录,清箱记录等进行实时监控,实时生成各种数据报表以及智能垃圾箱周围民众画像',
              url: '',
            },
            { title: '垃圾投放积分兑换',
              subtitle: '',
              desc: '利用物联网以及大数据根据让合规分类投放垃圾的居民获得积分，利用兑换机制的正反馈有效的提高民众垃圾分类投放的积极性',
              url: '',
            },
            { title: '垃圾分类知识宣传体系',
              subtitle: '',
              desc: '利用微信小程序以及智能垃圾箱的电子广告版，实现垃圾分类小知识查询，垃圾分类宣传视频等，提高垃圾分类知识的普及程度，加强用户垃圾分类的规范投放意识',
              url: '',
            },
            { title: '督导员以及管理',
              subtitle: '',
              desc: '利用GPS以及微信小程序对垃圾分类投放后的过程进行监管，实时获取车辆以及督导员的各类相关信息，可以实时查看信息，行动轨迹，操作记录，预约回收，问题上报等功能',
              url: '',
            },
          ],
          children: [] 
        },
        {},
        {},
        { name: '成功案例', children: [{ label: '洛阳垃圾分类大数据监管平台', desc: '利用物联网技术，对企业信息进行管理，规范其基础信息，收集企业工况信息...', path: '/detail_page/CaseZhongZaiShengDetail3' }] 
        },
      ],
      zzytyy: [
        { name: '产品痛点', children: [
          { label: '01', desc: '危险废物对生态环境和人体健康危害较大' },
          { label: '02', desc: '缺乏固体废物特别是危险废物的有效监管措施，固体废物倾倒案件频发' },
          { label: '03', desc: '监管人员不足、专业水平不足、监管不到位的问题' },
          { label: '04', desc: '功能单一，信息化管理不完善，固体废物转移过程未得到监管' },
          { label: '05', desc: '结构集成，操作繁琐' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '平台门户',
              subtitle: '',
              desc: '平台门户为产废单位、医疗机构、运输单位以及经营单位开放了不同的服务以填报相关数据',
              url: '',
            },
            { title: '产废单位监管',
              subtitle: '',
              desc: '产废单位监管用于生态环境局对产废企业的危废及其他环保相关信息监督管理',
              url: '',
            },
            { title: '运输单位监管',
              subtitle: '',
              desc: '通过应用物联网和移动互联网技术，为危险废物转移精细化监管提供了技术解决方案',
              url: '',
            },
            { title: '经营单位监管',
              subtitle: '',
              desc: '通过平台对经营单位进行经营资质审核、电子联单查询、危废出入库记录查看以及企业年度报表和处置过程视频监控，可以极大提高环保部门对危废经营单位监管的效率',
              url: '',
            },
            { title: '医疗机构监管',
              subtitle: '',
              desc: '医疗机构监管用于生态环境局对医疗机构废物及其他环保相关信息监督管理',
              url: '',
            },
            { title: '综合管理',
              subtitle: '',
              desc: '综合管理包括企业信息变更审核、企业变更信息查询以及电子联单管理等功能模块',
              url: '',
            },
            { title: '危险废物规范化管理',
              subtitle: '',
              desc: '危险废物规范化考核设置APP端和PC端两端，可以通过手机移动端在现场考核，也可在PC端进行考核及考核记录查看',
              url: '',
            },
            { title: '辅助决策',
              subtitle: '',
              desc: '辅助决策主要提供分析决策和辅助执法等功能，对各种采集数据建立对应的数据模型进行分析，为生态环境局提供有用的决策信息',
              url: '',
            },
            { title: '卫星动态遥感图及反演数据',
              subtitle: '',
              desc: '卫星遥感对表征地理系统及对其的动态监测至关重要。通过gis技术和人工智能算法识别出疑似填埋点以供监管部门安排无人机及工作人员核实',
              url: '',
            },
            { title: '监管一张图',
              subtitle: '',
              desc: '通过监管一张图实现对危废的产生到处置全过程数据的采集及监管',
              url: '',
            },
          ],
          children: [] 
        },
        {},
        {},
        { name: '成功案例', children: [{ label: '清远市医用可回收物监控管理平台', desc: '利用物联网技术，对企业信息进行管理，规范其基础信息，收集企业工况信息...', path: '/detail_page/CaseZhongZaiShengDetail2' }] },
      ],
      zzytdsj: [
        { name: '产品痛点', children: [
          { label: '01', desc: '污染源企业采用纸质档案管理，数据同步不及时' },
          { label: '02', desc: '企业排污数据不能及时掌握，无法做到及时处理和预警' },
          { label: '03', desc: '监管人员对于污染源企业监管成本高，沟通以及处理效率低' },
          { label: '04', desc: '企业污染申报，污染处理等数据存在数据壁垒' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '企业数据信息化',
              subtitle: '',
              desc: '通过将企业信息，污染申报信息，污染处理信息等数据进行整合并以“一企一档”的形式汇总至系统中，可以高效及时的查看污染源企业的相关信息以及各类环保数据',
              url: '',
            },
            { title: '智能污染数据监测和分析',
              subtitle: '',
              desc: '利用物联网以及各类智能污染监测设备将企业污染数据实时获取，并利用大数据对各类污染类型进行统计和分析，达到及时预警的作用',
              url: '',
            },
            { title: '开发APP和小程序应用端',
              subtitle: '',
              desc: '提高监管人员获取通知，上报检查结果的效率。并且可以通过APP随时随地查看企业相关信息以及污染源相关数据',
              url: '',
            },
            { title: '企业污染线上办事大厅',
              subtitle: '',
              desc: '环保申报线上化，对企业环保申报无纸化处理，降低企业申报成本，提高申报审核效率。并且利用智能算法根据实际企业排污量进行核对和分析，提高对企业污染源的管理和记录效率',
              url: '',
            },
          ],
          children: [] 
        },
        {},
        {},
        { name: '成功案例', children: [{ label: '金沙县环保大数据监管平台', desc: '提高企业信息更新效率以及申报效率，并且可以实时查看企业各类信息...', path: '/detail_page/CaseZhongZaiShengDetail0' }] 
        },
      ],
      znsj: [
        { name: '产品痛点', children: [
          { label: '01', desc: '行业内资料保密，无共享，技术封闭、行业技术提升慢' },
          { label: '02', desc: '线下设计进行团队、工期、资料管理，过程管理混乱' },
          { label: '03', desc: '文本线下编制工期长，成本高' },
          { label: '04', desc: '设计团队和客户无协同，设计工期长、变更多，费用高' },
          { label: '05', desc: '客户不能实时、快速了解行业状况和项目决策依据' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title : '在线咨询问题解决方案',
              subtitle: '',
              desc: '通过在线咨询功能实时标准咨询、在线问答、专家答疑，快速了解行业状况，为项目前期规划、中期建设、后期运营提供决策依据',
              url: require('@/assets/images/solution/znsj_p1.png'),
            },
            { title: '资料管理问题解决方案',
              subtitle: '',
              desc: '可通过资料管理功能实现行业内资料、技术实时共享，促进行业进步' ,
              url: require('@/assets/images/solution/znsj_p2.png'),
            },
            { title: '在线生成问题解决方案',
              subtitle: '',
              desc: '一键生成方案、可研等文本资料，缩短工期、减少费用' ,
              url: require('@/assets/images/solution/znsj_p3.png'),
            },
            { title: '协同设计问题解决方案',
              subtitle: '',
              desc: '通过平台化管理和业主、设计院各专业间设计过程相互协同，实现设计阶段团队、工期、资料管理线上化，规范管控、缩短工期、减少变更、降低费用' ,
              url: require('@/assets/images/solution/znsj_p4.png'), 
            },
          ],
          children: [
            { label : '在线咨询',
            desc: '客户实时、快速了解行业状况，为项目前期规划、中期建设、后期运营提供决策依据',
            url: require('@/assets/images/solution/znsj_01.png'),
            },
            { label: '资料共享',
              desc: '打破行业内资料保密壁垒，技术实时共享，促进行业进步' ,
              url: require('@/assets/images/solution/znsj_02.png'), 
            },
            { label: '在线生成',
              desc: '一键生成方案、可研等文本资料，缩短工期、减少费用' ,
              url: require('@/assets/images/solution/znsj_03.png'),
            },
            { label: '平台管理',
              desc: '设计阶段实现团队、工期、资料管理线上化，规范管控、缩短工期、减少变更' ,
              url: require('@/assets/images/solution/znsj_04.png'), 
            },
            { label: '协同设计',
              desc: '实现业主、设计院各专业间设计过程相互协同，缩短工期、 减少变更、降低费用' ,
              url: require('@/assets/images/solution/znsj_05.png'),
            },
          ] 
        },
        {},
        {},
        { name: '成功案例', children: [
          { label: '旺能智能管控系统', desc: '利用物联网关将PLC等控制系统数据统一采集，通过4G网络上传至云端服务器，实现设备远程监控...', path: '/solition_lower/CaseDetail' },
          { label: '赤峰智能收运系统', desc: '提供车辆定位导航，利用大数据模型算法技术实现路径优化、智能调度，从而大大提升了收运效率...', path: '/solition_lower/CaseCfznsyDetail' },
          { label: '中节能智能管控系统', desc: '通过传感器采集数据，系统进行数据分析，及时提供预警消息，确保环境安全...', path: '/solition_lower/CaseZjnxhjjDetail' },
          { label: '茅台酒糟智能管控系统', desc: '通过分布式智慧控制系统的构建，依托整体平台的定位，将数据直观、动态、智慧、交互的展示和运行...', path: '/solition_lower/CaseZjnznhDetail' }]
        },
      ],
      zngy: [
        { name: '产品痛点', children: [
          { label: '01', desc: '各种区域型、垂直型的B2B平台形成体系内的数据孤岛' },
          { label: '02', desc: '线下采购、采购工期、寻源、比价过程管理混乱' },
          { label: '03', desc: '行业总包商、代理商差价' },
          { label: '04', desc: '签约耗费大量人力、物力、往返快递时间' },
          { label: '05', desc: '人员专门统计，效率低' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '平台型数据链场景融资',
              subtitle: '',
              desc: '金融机构与线上商业交易平台合作，在线获取翔实可追溯、拟合度较高的交易数据，通过控制场景交易产生的订单流、物流、现金流等数据，为平台上的买方或卖方提供的在线融资业务',
              url: require('@/assets/images/solution/zngy_p1.png'),
            },
            { title: '数字化、场景化趋势下，金融科技赋能供应链',
              subtitle: '',
              desc: '云计算的运用、智能终端的普及、大数据分析及处理技术的提高，放大了产业链企业或平台对场景数据资源的共享及价值挖掘，提升其生产、经营的智能化及信息化水平，助力供应链金融实现供需两端的精准高效对接',
              url: require('@/assets/images/solution/zngy_p2.png'),
            },
          ],
          children: [
            { label : '大数据分析与处理',
              desc: '服务上下游企业，盘活产业链资金',
              url: require('@/assets/images/solution/zngy_01.png'),
            },
            { label: '云计算的运用',
              desc: '商业交易高效化、便利化，打造场景+金融一体化' ,
              url: require('@/assets/images/solution/zngy_02.png'), 
            },
            { label: '系统快接',
              desc: '助力供应链金融实现供需两端的精准高效对接' ,
              url: require('@/assets/images/solution/zngy_03.png'),
            },
            { label: '智能终端的应用',
              desc: '智能终端的普及，放大了产业链企业或平台对场景数据资源的共享及价值挖掘',
              url: require('@/assets/images/solution/zngy_04.png'),
            }] 
        },
        {},
        {},
        { name: '成功案例', children: [
          { label: '旺能智能管控系统', desc: '利用物联网关将PLC等控制系统数据统一采集，通过4G网络上传至云端服务器，实现设备远程监控...', path: '/solition_lower/CaseDetail' },
          { label: '赤峰智能收运系统', desc: '提供车辆定位导航，利用大数据模型算法技术实现路径优化、智能调度，从而大大提升了收运效率...', path: '/solition_lower/CaseCfznsyDetail' },
          { label: '中节能智能管控系统', desc: '通过传感器采集数据，系统进行数据分析，及时提供预警消息，确保环境安全...', path: '/solition_lower/CaseZjnxhjjDetail' },
          { label: '茅台酒糟智能管控系统', desc: '通过分布式智慧控制系统的构建，依托整体平台的定位，将数据直观、动态、智慧、交互的展示和运行...', path: '/solition_lower/CaseZjnznhDetail' }]
        },
      ],
      sggl: [
        { name: '产品痛点', children: [
          { label: '01', desc: '施工周期长，均180天以上' },
          { label: '02', desc: '管理成本高，平均吨投资50万元以上' },
          { label: '03', desc: '施工质量不稳定' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '安全管理预防化',
              subtitle: '',
              desc: '实时识别、快速预警、提前响应</br>全面感知、系统分析、预先控制',
              url: require('@/assets/images/solution/gcgl_p1.png'),
            },
            { title: '质量管理智能化',
              subtitle: '',
              desc: '设备材料预制化、标准化、数据化</br>安装过程简易、规范、高效</br>按规范可实现质量可控',
              url: require('@/assets/images/solution/gcgl_p2.png'),
            },
            { title: '材料供应实时化',
              subtitle: '',
              desc: '自动预警</br>自动清点</br>质量追踪与溯源',
              url: require('@/assets/images/solution/gcgl_p3.png'),
            },
          ],
          children: [
            { label : '注册与分类管理',
              desc: '对参与主体信息审核，注册登记；施工数据分类管理',
              url: require('@/assets/images/solution/gcgl_01.png'),
            },
            { label: '交易管理',
              desc: '在施工过程中，通过工程施工管理平台将施工任务外包、便利化，打造场景+金融一体化' ,
              url: require('@/assets/images/solution/gcgl_02.png'), 
            },
            { label: '智能工程管理',
              desc: '过程信息进采集和处理；建造服务集成；智能施工管理、智能材料追溯' ,
              url: require('@/assets/images/solution/gcgl_03.png'),
            },
            { label: '监督管理',
              desc: '对交易过程及服务实施过程监管；通过接口与相关政府部门的监管系统相连',
              url: require('@/assets/images/solution/gcgl_04.png'),
            }] 
        },
        {},
        {},
        { name: '成功案例', children: [
          { label: '旺能智能管控系统', desc: '利用物联网关将PLC等控制系统数据统一采集，通过4G网络上传至云端服务器，实现设备远程监控...', path: '/solition_lower/CaseDetail' },
          { label: '赤峰智能收运系统', desc: '提供车辆定位导航，利用大数据模型算法技术实现路径优化、智能调度，从而大大提升了收运效率...', path: '/solition_lower/CaseCfznsyDetail' },
          { label: '中节能智能管控系统', desc: '通过传感器采集数据，系统进行数据分析，及时提供预警消息，确保环境安全...', path: '/solition_lower/CaseZjnxhjjDetail' },
          { label: '茅台酒糟智能管控系统', desc: '通过分布式智慧控制系统的构建，依托整体平台的定位，将数据直观、动态、智慧、交互的展示和运行...', path: '/solition_lower/CaseZjnznhDetail' }]
        },
      ],
      jzgl: [
        { name: '产品痛点', children: [
          { label: '01', desc: '僵化刻板，被动执行' },
          { label: '02', desc: '人为控制，效率低' },
          { label: '03', desc: '利益不同，无法共赢' },
          { label: '04', desc: '激励作用弱，业绩赋能低' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '机制系统采用的技术',
              subtitle: '',
              desc: '机制系统采用微服务、Docker容器、分布式、前后端分离等开发手段，确保系统的先进性和可扩展性，已经灵活性；在模型开发方面使用物联网、大数据分析技术，AI，机器自学习技术，来训练提升模型的稳定性',
              url: require('@/assets/images/solution/jzgl_p1.png'),
            },
            { title: '订单流集成解决方案',
              subtitle: '',
              desc: '使用分布式微服务架构，服务调用增加身份授权认证，通过事务核对在保证数据高度一致性的基础上，使各个子系统产生的增效订单信息安全的传递到机制系统，并最终推送给财务系统，完成各系统订单流的集成',
              url: require('@/assets/images/solution/jzgl_p2.png'),
            },
            { title: '机制增收模型解决方案',
              subtitle: '',
              desc: '机制后台系统对累计的大量用户数据：成交量、成交额、交易频率、激励幅度等信息，做大数据分析，产生最佳增收模型，并通过机器学习，对更多影响数据进行提取和优化，完善模型，不断提高平台增收',
              url: require('@/assets/images/solution/jzgl_p3.png'),
            },
          ],
          children: [
            { label : '运营平台',
              desc: '包括收运系统、预处理系统、厌氧系统、生产管控系统',
              url: require('@/assets/images/solution/jzgl_01.png'),
            },
            { label: '工程建设平台',
              desc: '包括智能设计系统、供应系统、工程管理系统' ,
              url: require('@/assets/images/solution/jzgl_02.png'), 
            },
            { label: '财务系统',
              desc: '包括收支系统、报表系统、纳税筹划系统、产业链金融系统等' ,
              url: require('@/assets/images/solution/jzgl_03.png'),
            },
            { label: '机制系统',
              desc: '包括外部激励系统、内部激励系统、提效和增收模型等',
              url: require('@/assets/images/solution/jzgl_04.png'),
            }] 
        },
        {},
        {},
        { name: '成功案例', children: [
          { label: '旺能智能管控系统', desc: '利用物联网关将PLC等控制系统数据统一采集，通过4G网络上传至云端服务器，实现设备远程监控...', path: '/solition_lower/CaseDetail' },
          { label: '赤峰智能收运系统', desc: '提供车辆定位导航，利用大数据模型算法技术实现路径优化、智能调度，从而大大提升了收运效率...', path: '/solition_lower/CaseCfznsyDetail' },
          { label: '中节能智能管控系统', desc: '通过传感器采集数据，系统进行数据分析，及时提供预警消息，确保环境安全...', path: '/solition_lower/CaseZjnxhjjDetail' },
          { label: '茅台酒糟智能管控系统', desc: '通过分布式智慧控制系统的构建，依托整体平台的定位，将数据直观、动态、智慧、交互的展示和运行...', path: '/solition_lower/CaseZjnznhDetail' }]
        },
      ],
      cwzx: [
        { name: '产品痛点', children: [
          { label: '01', desc: '项目回款难' },
          { label: '02', desc: '税负较高，缺少税收筹划' },
          { label: '03', desc: '数据分析工作量大，重复工作' },
          { label: '04', desc: '中小企业融资困难，影响企业发展' }] 
        },
        { 
          name: '主要功能', 
          card: [
            { title: '支付问题解决方案',
              subtitle: '',
              desc: '财务系统实现了所有支付相关的操作，并提供API接口，保障第三方银联支付和平台各个子产品之间的资金流动，为平台子产品提供安全、快捷、简单的支付方式，实现平台“资金流”集成',
              url: require('@/assets/images/solution/cwgl_p1.png'),
            },
            { title: '报表问题解决方案',
              subtitle: '',
              desc: '通过数据采集、分析、展示，可清晰的看到各经济指标完成情况。同时，数据分析也可以指导企业经营，提高公司运行效率',
              url: require('@/assets/images/solution/cwgl_p2.png'),
            },
            { title: '企业融资解决方案',
              subtitle: '',
              desc: '产业链金融以环境产业平台为基础，与平台优势和行业特征相结合，将自身更好融入行业的生态供应链中，将上游供货商和下游消费者通过平台的结合形成产业链闭环，通过所掌握的数据分析完成对贷款者的资产或信用评估，利用产业链的资金流通完成对产业链中资金需求方的支持',
              url: require('@/assets/images/solution/cwgl_p3.png'),
            },
            { title: '税收问题解决方案',
              subtitle: '',
              desc: '通过在线咨询，提供符合企业需要的税收筹划方案，可实时看到预测减税数据，帮助企业完成税收筹划，为企业节约税收成本',
              url: require('@/assets/images/solution/cwgl_p4.png'),
            },
          ],
          children: [
            { label : '支付管理',
              desc: '提供担保交易',
              url: require('@/assets/images/solution/cwgl_01.png'),
            },
            { label: '报表管理',
              desc: '报表实时生成' ,
              url: require('@/assets/images/solution/cwgl_02.png'), 
            },
            { label: '产业链金融',
              desc: '提供融资服务' ,
              url: require('@/assets/images/solution/cwgl_03.png'),
            },
            { label: '税收筹划',
              desc: '降低税收成本',
              url: require('@/assets/images/solution/cwgl_04.png'),
            }] 
        },
        {},
        {},
        { name: '成功案例', children: [
          { label: '旺能智能管控系统', desc: '利用物联网关将PLC等控制系统数据统一采集，通过4G网络上传至云端服务器，实现设备远程监控...', path: '/solition_lower/CaseDetail' },
          { label: '赤峰智能收运系统', desc: '提供车辆定位导航，利用大数据模型算法技术实现路径优化、智能调度，从而大大提升了收运效率...', path: '/solition_lower/CaseCfznsyDetail' },
          { label: '中节能智能管控系统', desc: '通过传感器采集数据，系统进行数据分析，及时提供预警消息，确保环境安全...', path: '/solition_lower/CaseZjnxhjjDetail' },
          { label: '茅台酒糟智能管控系统', desc: '通过分布式智慧控制系统的构建，依托整体平台的定位，将数据直观、动态、智慧、交互的展示和运行...', path: '/solition_lower/CaseZjnznhDetail' }]
        },
      ],
      wpt: [
        { name: '产品痛点', children: [
          { label: '01', desc: '基于数据保密的考虑企业不愿上平台和用平台' },
          { label: '02', desc: '满足不了企业降本增效核心需求' },
          { label: '03', desc: '一般平台产品无法满足企业个性化需求' },
          { label: '04', desc: '无法做到持续升级赋能' }
        ] },
        { name: '主要功能' , card: [], children: [
            { label : '边缘侧智能管控',
              desc: '满足企业数据和管控私有化部署需求，将平台功能下沉进行智能化生产管控，实现提质、降本、增效、绿色和安全',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '功能升级',
              desc: '根据用户所需不定期与平台连接，将平台新模型封装，通过预留接口下沉实现自动升级，提供持续技术支撑' ,
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '与平台随时连接',
              desc: '可设置与E-平台的连接与断开，并可选择开放或关闭的功能与数据，保障微平台的先进性与私密性' ,
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '满足个性化需求',
              desc: '技术的发展越先进，平台的颗粒度越小，选择的自由度越大，自主的开发越容易实现，满足的个性化需求越到位，获得的服务越灵活方便。',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            }
          ] },
        { name: '应用场景', desc: '' , url: [require('@/assets/images/product/img_wei_002.png'),] }
      ],
      wlwpt: [
        { name: '主要能力', children: [
          { label: '01', desc: '提供各类硬件终端的快速接入方案和设备管理服务' },
          { label: '02', desc: '支持根据设备数量水平扩展能力' },
          { label: '03', desc: '支持统一的物模型管理，支持边缘计算' },
          { label: '04', desc: '支持统一的物模型管理，支持边缘计算' },
          { label: '05', desc: '提供丰富的API和数据分发能力' }
        ] },
        { name: '核心功能', card: [], children: [
            { label : '多类型物联设备快速接入',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
              desc: [
                "提供设备端SDK帮助不同设备轻松接入云。",
                "提供 2G/3G/4G、NB-IoT、LoRa、WiFi等不同网络设备接入方案，解决企业异构网络设备接入管理痛点。",
                "提供 MQTT、CoAP、WebSocket、HTTP/S 等多种协议，既满足长连接的实时性需求，也满足短连接的低功耗需求。",
                "持自定义协议的脚本化解码及编码配置。",
                "开源多种平台设备端代码，提供跨平台移植指导，赋能企业基于多种平台做设备接入。",
              ]
            },
            { label: '设备生命周期管理',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
              desc: [
                "提供通用物联网模型，简化应用开发。  ",
                "支持OTA升级，为设备提供远程升级。",
                "提供设备影子缓存机制，将设备与应用解耦，解决不稳定无线网络下的通信不可靠痛点。",
              ]
            },
            { label: '规则引擎',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
              desc: [
                "支持热插拔式脚本级处理器配置规则，实现不同场景下的定制化数据采集及数据处理需求。  ",
                "数据流转规则可以对设备上报的数据进行简单处理，并将处理后的数据流转到其他Topic、分布式消息服务Kafka，支持存储到时序数据库。",
                "通过条件触发，基于预设的规则，引发多设备的协同反应，实现设备联动、智能控制。",
              ]
            },
            { label: '海量存储能力',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
              desc: [
                "提供数据存储能力，方便用户海量设备数据的存储及实时访问。",
                "支持业界多种时序数据库，根据客户需求配置不同类型分布式数据源。",
                "租户级存储，保证信息安全，支持物联数据的导出。",
              ]
            },
            { label: '多维度安全保障',
              url: [require('@/assets/images/developerCommunity/icon_func_nor.png'),],
              desc: [
                "提供一机一密的设备认证机制，降低设备被攻破的安全风险。",
                "支持设备权限管理机制，保障设备与云端安全通信。",
                "支持TLS（MQTT\\HTTP）、DTLS(CoAP)数据传输通道，保证数据的机密性和完整性，适用于硬件资源充足、对功耗不是很敏感的设备。",
                "支持设备级别的通信资源（Topic等）隔离，防止设备越权等问题。",
                "支持多租户模式，租户间数据隔离。",
              ]
            },
          ] },
        { name: '功能架构', desc: '' , url: [require('@/assets/images/product/img_wulianwang_05.png'),] }
      ],
      mxglpt: [
        { name: '主要特点', children: [
          { label: '01', desc: '一体化的模型发布、统管平台' },
          { label: '02', desc: '模型全生命周期管理——全程可追溯' },
          { label: '03', desc: '云端/边缘端两种快捷部署升级方式，赋能子平台、微平台' },
          { label: '04', desc: '增效结果直观可见' },
          { label: '05', desc: '拖拽式界面操作完成模型融合，实现1+1+1>3的增效目标' }
        ] },
        { name: '核心功能', card: [], children: [
            { label : '全方位管理模型',
              desc: '模型管理平台覆盖上线模型管理的各个方面，包括评估、测试、监控以及版本和权限管理将模型上线前后的流程细分为12个重要环节，实现对模型的精准管理和监控，防止模型上线混乱提升了企业管理模型的效率',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '监控指标标准化',
              desc: '模型管理平台基于大量的实际案例，在系统稳定性指数、变量稳定性指数、转移矩阵、SVD、Somers’D等监控指标和验证指标的基础上，梳理出了模型评估监控的常用指标，支持KS、AUC、ROC、F1、AR、准确率、稳定性指数等指标自定义配置，实现模型评估监控的标准化' ,
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '自动化监控预警',
              desc: '模型管理平台以自动化的方式计算各种评估指标，根据模型衰退和数据变化自动预警。其中，监控数据可在模型详情页中查看模型的评价指标值和对应的图表数据' ,
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '全新的系统架构',
              desc: '模型管理平台引入了微服务的架构思想，以“专题-数据集-模型”分层管理为思路，按照分区治理的理念，划分沙箱区和生产区，极大地简化了模型上下线的审核流程，降低了系统操作的复杂度，提升了系统的可拓展性',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            // { label: '可视化操作界面',
            //   desc: '平台提供可视化操作界面，屏蔽了底层复杂的分布式存储和计算引擎，提高开发和运维效率',
            //   url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            // },
            // { label: '融合机器学习和智能报表平台',
            //   desc: '实现了与机器学习平台、智能报表平台的有效融合，拓展了深度业务分析和可视化能力',
            //   url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            // }
          ] },
        { name: '平台架构', desc: '' , url: [require('@/assets/images/product/img_moxing_005.png'),] }
      ],
      sjzx: [
        { name: '主要能力', children: [
          { label: '01', desc: '统一数据采集规范，支持异构数据源数据引入' },
          { label: '02', desc: '一站式可视化环境产业数据研发工作平台' },
          { label: '03', desc: '对数据进行全生命周期的资产化管理' },
          { label: '04', desc: '支持分布式引擎架构，支持离线计算和实时计算' },
          { label: '05', desc: '实现与机器学习平台、智能报表平台的有效融合' }
        ] },
        { name: '核心功能', card: [], children: [
            { label : '海量异构行业数据采集融合',
              desc: '实现了海量异构行业数据的采集融合，打破数据孤岛,解决了数据流不动的难题',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '行业数据全生命周期管理',
              desc: '对行业数据的全生命资产化管理，实现了数据采集、清洗、分析的过程管理，数据归档、数据销毁、以及全生命周期监控' ,
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '行业大数据分布式存储',
              desc: '采用当前流行的大数据技术，采用高性能大数据集群，对行业大数据进行分布式存储' ,
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '行业大数据快速分析',
              desc: '平台支持分布式引擎架构，支撑离线计算和实时计算，实现了行业大数据快速分析。',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '可视化操作界面',
              desc: '平台提供可视化操作界面，屏蔽了底层复杂的分布式存储和计算引擎，提高开发和运维效率',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '融合机器学习和智能报表平台',
              desc: '实现了与机器学习平台、智能报表平台的有效融合，拓展了深度业务分析和可视化能力',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            }
          ] },
        { name: '功能架构' , desc: '' , url: [require('@/assets/images/product/img_shujuzt_jg.png'),] }
      ],
      bsjxfw: [
        {},
        {},
        { name: '服务介绍', desc: '国真智慧承担国家工业互联网标识体系二级节点建设运营工作，环境产业标识解析应用服务平台底层对接国家标识解析基础资源，上层应用在垃圾追溯、碳足迹、智能生产、供应链管理、全生命周期管理等业务场景应用模式中，赋能环卫、环保企业快速便捷地使用标识解析服务，提升企业间数据协同，为碳达峰碳中和目标实现提供新基础设施，助力环境产业数字经济高质量发展', url:[require('@/assets/images/product/img_fuwu_001.png'),], children: [] },
        { name: '功能架构', desc: '' , url: [require('@/assets/images/product/img_fuwu_002.png'),] }
      ],
      cprzfw: [
        // { name: '认证服务范围' , children: [
        //   { label: '01', desc: '固废处理处置设备' },
        //   { label: '02', desc: '污水治理设备' },
        //   { label: '03', desc: '大气治理设备' },
        //   { label: '04', desc: '噪音控制设备' },
        //   { label: '05', desc: '辐射控制设备等' }
        // ] },
        { name: '测试服务范围' , children: [
          { label: '01', desc: '固废、污水等处置设备' },
          { label: '02', desc: '固废、污水污水等处置管理软件产品' },
          { label: '03', desc: '其他环境处置设备及软件产品' },
        ] },
        { name: '我们提供的服务', card: [], children: [
            { label : '中国环境设备排放达标测试（DSDC：China Environment Device Standard Discharge Certification ）',
              desc: '是国真智慧测试中心开展的一项产品测试工作，使用工业互联网等技术手段实时采集设备运行数据，对各类环境保护、处理、处置等设备的排放情况进行确认，并以在线标志图形的形式告知消费者哪些产品符合环境保护要求，对生态环境更为有利。降低监管风险、提升企业品牌声誉，同时也提升市场竞争力。',
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
            { label: '中国环境设备增效测试（DEC：China Environment Device Efficiency Certification ）',
              desc: '是国真智慧测试中心开展的一项产品测试工作，使用工业互联网等技术手段实时采集设备运行数据，通过设备增效模型分析验证其增效空间，为企业降本、增效、提质提供设备增效技术测试服务。' ,
              url: require('@/assets/images/developerCommunity/icon_func_nor.png'),
            },
          ] },
        { name: '测试流程' , desc: '' , url: [require('@/assets/images/product/img_chanpincx_001.png'),], children: [] }
      ],
      ptywfw: [
        { name: '主要能力' , children: [
          { label: '01', desc: '通过使用微平台（数据模型、机理模型）实现项目的增效并实现项目无人智能工厂运行' },
          { label: '02', desc: '使用厌氧子平台中的管控模块，可以对运行设备进行数据收集进行设备运行状态的故障预测修复与保养维护' },
        ] },
        {},
        { name: '运维阶段' , desc: '' , url: [require('@/assets/images/product/img_ptyw1.png'),], children: [] },
        { name: '预期目标' , desc: '1、生产企业通过运维平台进行运维增效20%以上。</br>2、生产企业通过运维平台实现无人智能工厂增效20%。（1人+1个智能狗）</br>3、年度厌氧子平台运维项目产值额度不低于1000万（增效分配+硬件）。' , url: [require('@/assets/images/product/img_ptyw2.png'),], children: [] }
      ],
      nccg: [
        { name: '产业痛点', children: [
          { label: '01', desc: '垃圾治理问题，垃圾山、垃圾围村、 垃圾围坝、工业污染“上山下乡”' },
          { label: '02', desc: '粪污污染问题，粪污未进行无害化处理， 存在渗漏现象，对环境造成污染' },
          { label: '03', desc: '生活污水问题，房前屋后河塘沟渠出现黑臭水体，水污染严重' },
          { label: '04', desc: '管护机制不完善问题，农村人居环境整治涉及范围广、环节多，各地各部门配合服务不完善' }] 
        },
        { 
          name: '主要功能', 
          children: [
            { label : '厕所革命',
              desc: '通过智能化平台建设厕改后期管护机制，建立覆盖到村到户、随叫随到的快捷服务体系',
              url: require('@/assets/images/solution/nccg_job1.png'),
            },
            { label: '垃圾治理',
              desc: '对垃圾全生命周期各要素整体态势和运行状况进行全方位掌控和监管，实现一体化治理' ,
              url: require('@/assets/images/solution/nccg_job2.png'), 
            },
            { label: '污水治理',
              desc: '利用物联网等技术，实现数据采集、监控、分析、考核等功能，提高污水治理效率' ,
              url: require('@/assets/images/solution/nccg_job3.png'),
            },
            { label: '村容村貌',
              desc: '对道路、危房等建筑设施，实现县、乡、村三级全覆盖管理，协同推进综合管理工作',
              url: require('@/assets/images/solution/nccg_job4.png'),
            }] 
        },
        { name: '三河市城乡人居环境整治智慧平台', 
          type: 'example',
          desc: '根据三河市的人文及地理特点，以城乡人居环境整治为服务内容，对于城乡废弃物进行协同处置及一体化监管，打造垃圾处理管控平台、厕改长效管护平台、污水智慧运营平台等多个应用，为人居环境整治提供统一的信息化智能化服务，打通三河不同主管部门的管理链条，推进三河治理工作进程，提高管理效率，为居民提供更好的居住环境。' , 
          url: [require('@/assets/images/product/nccg_product01.png'),] 
        },
        {},
        // { name: '成功案例', children: [{ label: '赤峰智能收运系统', desc: '提供车辆定位导航，利用大数据模型算法技术实现路径优化、智能调度，从而大大提升了收运效率...', path: '/solition_lower/CaseCfznsyDetail' }] },
      ],
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/ProductDetails/data.js